module.exports = __webpack_public_path__ + "img/category-temporal-reverse.d4a77632.svg";